import { descriptorPropTypes } from "lib/common/descriptorcontrols/formhelpers";
import EntityProxy from "data/util/EntityProxy";
import React from "react";
import PropTypes from "prop-types";
import Kids from "lib/dataentry/lib/dataentryform/formitems/Kids";

export class Layoutcolumnset extends React.Component {
    render() {
        const {
            descriptor
        } = this.props;
        return (
            <div
                key={descriptor.key}
                id={descriptor.id}
                className={`control-layout-${descriptor.key} control-layout-columnset`}
            >
                <Kids {...this.props} controlOnly={false} />
            </div>
        );
    }

}

Layoutcolumnset.propTypes = {
    descriptor: PropTypes.shape(descriptorPropTypes(null, false, true)),
    fluxContext: PropTypes.string.isRequired,
    activeRecord: PropTypes.instanceOf(EntityProxy).isRequired
};

export default Layoutcolumnset;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/formitems/Layout/columnset.js